import { FASTElement, customElement, attr, css, Updates } from '@microsoft/fast-element';
import template from './template.js';
import styles from './styles.js';

@customElement({
	name: 'section-header',
	template,
	styles
})
export class SectionHeader extends FASTElement {
	@attr
	public type: string = 'section';
}